import React, {Component} from 'react';
import './App.css';
import AuthSignupScreen from "./Auth/AuthSignupScreen";
import AuthLoginScreen from "./Auth/AuthLoginScreen";
import AuthStartScreen from "./Auth/AuthStartScreen";
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom';
import SessionHelper from "./System/SessionHelper";
import GuestlistScreen from "./Portal/Guestlist/GuestlistScreen";
import GuestlistAddScreen from "./Portal/Guestlist/GuestlistAddScreen";
import AuthPasswordScreen from "./Auth/AuthPasswordScreen";
import OverviewScreen from "./Portal/Overview/OverviewScreen";
import AccountScreen from "./Portal/Account/AccountScreen";
import GuestlistDetailScreen from "./Portal/Guestlist/GuestlistDetailScreen";
import WishlistOverviewScreen from "./Portal/Wishlist/WishlistOverviewScreen";
import PlannerOverviewScreen from "./Portal/Planner/PlannerOverviewScreen";
import WishlistWizard from "./Portal/Wishlist/WishlistWizard";
import PlannerOverviewScreen2 from "./Portal/Planner/PlannerOverviewScreen2";
import AuthResetScreen from "./Auth/AuthResetScreen";

class App extends Component {
    render() {
        return (
            <div className="App">
                <SessionHelper>
                    <Router>
                        <div>
                            <Route path="/" render={({location}) => {
                                if (typeof window.ga === 'function') {
                                    const gaPageUrl = location.pathname + location.search;
                                    console.log('GA navigation event:', gaPageUrl);

                                    window.ga('set', 'page', gaPageUrl);
                                    window.ga('send', 'pageview');
                                }

                                return null;
                            }}/>
                            <Switch>
                                {/* Auth */}
                                <Route exact path={"/"} component={AuthStartScreen}/>
                                <Route exact path={"/inloggen"} component={AuthLoginScreen}/>
                                <Route exact path={"/aanmelden"} component={AuthSignupScreen}/>
                                <Route exact path={"/wachtwoord"} component={AuthPasswordScreen}/>
                                <Route exact path={"/reset/:uid/:token"} component={AuthResetScreen}/>
                                {/* Portal main */}
                                <Route exact path={"/start"} component={OverviewScreen}/>
                                <Route exact path={"/account"} component={AccountScreen}/>
                                {/* Guest list */}
                                <Route exact path={"/gasten"} component={GuestlistScreen}/>
                                <Route exact path={"/gasten/toevoegen"} component={GuestlistDetailScreen}/>
                                <Route exact path={"/gasten/batch"} component={GuestlistAddScreen}/>
                                <Route path={"/gasten/:id"} component={GuestlistDetailScreen}/>
                                {/* Wish list */}
                                <Route exact path={"/wensen"} component={WishlistOverviewScreen}/>
                                <Route exact path={"/wensen/wizard"} component={WishlistWizard}/>
                                <Route exact path={"/praktisch"} component={WishlistOverviewScreen}/>
                                <Route exact path={"/praktisch/wizard"} component={WishlistWizard}/>
                                {/* Planner */}
                                <Route exact path={"/draaiboek"} component={PlannerOverviewScreen}/>
                                <Route exact path={"/draaiboek/:tab"} render={(props) => <PlannerOverviewScreen {...props} seedMode={false}/>}/>
                                <Route exact path={"/draaiboek/:tab/start"} render={(props) => <PlannerOverviewScreen2 {...props} seedMode={true}/>}/>
                                {/* 404 Fallback */}
                                <Route>
                                    <Redirect to={"/"}/>
                                </Route>
                            </Switch>
                        </div>
                    </Router>
                </SessionHelper>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js